import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Table,
  Label
} from "reactstrap";

import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  Tbody,
  Th,
  Thead,
  Tr
} from "react-super-responsive-table";

import { MetaTags } from "react-meta-tags";

import {
  getInternalTransferAutomationInit,
  internalTransferAutomationAction
} from "../../store/forexTransactions/internalTransfers/actions.js";

function TransferSetting() {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(true);
  // Get toggle value from Redux
  const isInternalTransferAuto = useSelector(
    (state) => state.internalTransferReducer.isInternalTransferAuto
  );

  // Load initial state from backend
  useEffect(() => {
    dispatch(getInternalTransferAutomationInit());
    setChecked(isInternalTransferAuto);
  }, [dispatch]);

  // Handle toggle change
  const handleToggle = (e) => {
    const newValue = e.target.checked;
    setChecked(newValue);
    dispatch(internalTransferAutomationAction(newValue));
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Transfer Settings</title>
      </MetaTags>

      <div className="page-content">
        <div className="container-fluid">
          <h2>Transfer Settings</h2>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table
                        id="tech-companies-1"
                        className="table table-hover"
                      >
                        <Thead className="text-center table-light">
                          <Tr>
                            <Th>
                              <span className="color-primary">
                                Internal Transfer Automation
                              </span>
                            </Th>
                            <Th>
                              <span className="color-primary">Status</span>
                            </Th>
                          </Tr>
                        </Thead>

                        <Tbody
                          className="text-center"
                          style={{ fontSize: "13px" }}
                        >
                          <Tr>
                            <td>Internal Transfer Automation</td>
                            <td>
                              <Input
                                type="checkbox"
                                id="internalToggle"
                                switch="none"
                                checked={checked}
                                onChange={handleToggle}
                              />
                              <Label
                                className="me-1"
                                htmlFor="internalToggle"
                                data-on-label=""
                                data-off-label=""
                              ></Label>
                            </td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

export default TransferSetting;
